module.exports = __webpack_public_path__ + "static/media/biocertica-logo-with-text-white-horizontal.e4de0c22.svg";